<template>
    <div class="c-checkbox" :class="{'c-checkbox--checked': state}">
        <input type="checkbox"
               class="c-checkbox__input"
               @change="emit"
               :id="id"
               :value="val"
               :true-value="true"
               :false-value="false"
               v-model="checked">

      <!--  <label class="c-checkbox__label" :for="id">

           <div class="c-checkbox__check">

                <svg class="c-checkbox__check"
                     xmlns='http://www.w3.org/2000/svg'
                     viewBox='0 0 64 64'
                     fill="transparent"
                     width='10' height='10'>
                    <path d='M0 32 L26 62 L62 4'/>
                </svg>
            </div>
            <div class="c-checkbox__border"></div>

        </label>
        -->

    </div>

</template>

<script>
    export default {
        name: "Checkbox",
        props: {
            value: {type: [Boolean, Array], default: false},
            val: {type: String, default: ""},
            name: {type: String, default: ""},
            id: {type: String, default: ""},
        },
        data() {
            return {
                checked: this.value
            }
        },
        computed: {
            state() {
                if (typeof this.value == "boolean") {
                    return this.checked;
                } else {
                    return this.value.indexOf(this.val) !== -1;
                }
            }
        },
        methods: {
            emit(){
                this.$emit('input', this.checked);
            }
        },
        watch: {
            /* checked() {
                this.$emit('input', this.checked);
            }, */
            value() {
                this.checked = this.value;
            }
        },
    }
</script>

<style lang="scss">

    //noinspection CssUnknownTarget
    @import '~@/scss/main.scss';

    .c-checkbox {

        &__input {
        }

        &__label {
            width: 1em;
            height: 1em;
            cursor: pointer;
            background-color: white;
            position: relative;
        }

        &__border {
            width: 1em;
            height: 1em;
            border: 2px solid $primary-color;
            transition: all 0.15s ease;
        }

        &__check {
            height: .6em;
            width: .6em;
            position: absolute;
            top: .2em;
            left: .2em;
            z-index: 1;
            stroke-dasharray: 100;
            stroke-dashoffset: 80;
            stroke-width: 10px;
            stroke: white;
            fill: transparent;
            opacity: 0;
            transition: all 0.35s ease-out;
        }

        &--checked {
            .c-checkbox__border {
                position: absolute;
                top: 0;
                left: 0;
                border: .5em solid $primary-color;
            }

            .c-checkbox__check {
                opacity: 1;
                stroke-dashoffset: 0;
            }
        }

    }


</style>